import { c as _c } from "react/compiler-runtime";
import dayjs from 'dayjs';
import type React from 'react';
import { useRef, useState } from 'react';

/**
 * 채팅 입력 관련 텔레메트리 상태를 담당한다.
 *
 * - chatInputRef: 입력 엘리먼트 참조.
 * - roomEnterTime: 방 입장 시각(광고성 채팅 판정에 사용).
 * - typingStart / markTypingStart: 입력 시작 시각(타이핑 속도 계산에 사용).
 * - lastKeyPressed / trackKeyPress: 직전 입력 방식(붙여넣기 cv vs 일반 any).
 *
 * 동작은 useChatComposer의 기존 입력 상태 로직과 동일하다.
 */
const useChatInputMeta = () => {
  const $ = _c(6);
  const [lastKeyPressed, setLastKeyPressed] = useState("default");
  const [typingStart, setTypingStart] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = dayjs().format("YYYY-MM-DD HH:mm:ss");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const roomEnterTime = useRef(t0);
  const chatInputRef = useRef(null);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setTypingStart(dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"));
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const markTypingStart = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => {
      if (event.ctrlKey && event.key === "v") {
        setLastKeyPressed("cv");
      } else {
        setLastKeyPressed("any");
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const trackKeyPress = t2;
  let t3;
  if ($[3] !== lastKeyPressed || $[4] !== typingStart) {
    t3 = {
      chatInputRef,
      roomEnterTime,
      typingStart,
      lastKeyPressed,
      markTypingStart,
      trackKeyPress
    };
    $[3] = lastKeyPressed;
    $[4] = typingStart;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default useChatInputMeta;